import { ZoomControls } from "../../../../../../components/Zoom/ZoomControls.tsx";
import { DESIGNER_CANVAS_ID } from "../constants.ts";
import { designerCanvasStore } from "../stores/designerCanvasStore.ts";

export const DesignerZoomControls = () => {
  const { zoomLevel, canvasSize } = designerCanvasStore.useState();

  return (
    <ZoomControls
      zoom={zoomLevel}
      onZoomSet={designerCanvasStore.setZoomLevel}
      defaultZoom={1}
      zoomableComponentRealSize={canvasSize ?? { width: 0, height: 0 }}
      zoomableComponentId={DESIGNER_CANVAS_ID}
    />
  );
};
